/**
 * Centralized token storage utility.
 * Wraps all auth token access in one place so storage strategy can be changed
 * (e.g., to httpOnly cookies or sessionStorage) without touching every file.
 *
 * Currently uses localStorage but all access goes through this module.
 */

const TOKEN_KEY = 'token';
const DASHBOARD_KEY = 'selectedDashboard';

export const tokenStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (token) => localStorage.setItem(TOKEN_KEY, token),
  removeToken: () => localStorage.removeItem(TOKEN_KEY),

  getDashboard: () => localStorage.getItem(DASHBOARD_KEY),
  setDashboard: (dashboard) => localStorage.setItem(DASHBOARD_KEY, dashboard),
  removeDashboard: () => localStorage.removeItem(DASHBOARD_KEY),

  clearAll: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(DASHBOARD_KEY);
  },
};
